import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import r from 'render-dom';
import styled from 'styled-components';

import Spinner from 'components/shared/Spinner';
import { borderColor } from 'constants/colors';
import { smallMax } from 'constants/mediaQueries';
import { targetBlank } from 'utils/helpers';

const StyledA = styled.a`
    display: inline-block;
    text-decoration: none;
`;

const StyledLink = styled(Link)`
    display: inline-block;
    text-decoration: none;
`;

const StyledButton = styled(motion.button)`
    align-items: center;
    background: ${(props) => {
        if (props.danger) {
            return 'red';
        }

        if (props.primary) {
            return 'black';
        }

        if (props.light) {
            return borderColor;
        }

        return '#fff';
    }};
    border: ${({ ghost }) => ghost ? '1px solid #ccc' : 'none'};
    border-radius: 30px;
    color: ${(props) => {
        if (props.primary) {
            return '#ccc';
        }

        if (props.danger) {
            return '#fff';
        }

        if (props.ghost) {
            return '#444';
        }

        return '#000';
    }};
    cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
    display: flex;
    font-family: 'effra', sans-serif;
    font-size: 14px;
    justify-content: center;
    outline: none;
    padding: 7px 20px;
    white-space: nowrap;

    @media(${smallMax}) {
        padding: 7px 13px;
    }

    &:disabled {
        opacity: 0.4;
    }
`;

const Icon = styled.i``;

export default function Button(props) {
    const {
        children,
        disabled,
        ghost = false,
        href = '',
        icon,
        isLoading,
        label,
        loadOnClick = false,
        onClick = Function.prototype,
    } = props;
    const [isLoadingState, setIsLoadingState] = useState(false);
    const showLoading = isLoading || isLoadingState;

    function handleClick(...args) {
        if (loadOnClick) {
            setIsLoadingState(true);
        }

        onClick(...args);
    }

    const button = (
        r(StyledButton, {
            ...props,
            disabled: disabled || showLoading,
            ghost,
            onClick: handleClick,
            whileHover: { scale: !disabled ? 1.04 : 1 },
            whileTap: { scale: !disabled ? 0.97 : 1 }
        }, [
            r(Fragment, { isRendered: !showLoading }, [
                r(Icon, {
                    className: `icon-${icon}`,
                    isRendered: Boolean(icon)
                }),
                children || r.span({ isRendered: label }, [label]),
            ]),
            r.span({ isRendered: showLoading }, [
                r(Spinner, {
                    color: ghost ? '#333' : '#fff',
                    size: 20,
                    style: { padding: 0 }
                }),
            ]),
        ])
    );

    if (href) {
        if (href.includes('//')) {
            return r(StyledA, targetBlank(href), [button]);
        }

        return r(StyledLink, { to: href }, [button]);
    }

    return button;
}

Button.propTypes = {
    className: PropTypes.string,
    danger: PropTypes.bool,
    disabled: PropTypes.bool,
    ghost: PropTypes.bool,
    icon: PropTypes.string,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    primary: PropTypes.bool,
    type: PropTypes.string,
};
